export function aiGeneratedNeedsReview(itemGroups) {
  for (const itemGroup of itemGroups) {
    for (const item of itemGroup.items || []) {
      if (item.aiGeneratedAnswerReviewed === false) {
        return true
      }
    }
  }
  return false
}
